export class StateHandler {

    protected _currentState: any;
    protected _lastState: any;

    public get value(): any { return this._currentState; }
    public get lastState(): any { return this._lastState; }

    constructor(state?: any) { this._lastState = this._currentState = state; }

    public equal(value: any): boolean { 
        return this.value === value;
    }

    public set(value: any): void {
        this._lastState = this._currentState;
        this._currentState = value;
    }
}

